<template>
  <div>
    <users-add
      :user-add-sidebar-active.sync="userAddSidebarActive"
      @refreshData="getUsers"
    />

    <users-edit
      v-if="updateShow"
      :user-id="Number(userId)"
      :user-edit-sidebar-active.sync="userEditSidebarActive"
      @refreshData="getUsers"
    />

    <users-password
      v-if="passwordShow"
      :user-id="Number(userId)"
      :user-password-sidebar-active.sync="userPasswordSidebarActive"
      @refreshData="getUsers"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
    >
      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              v-if="userData().role === 'admin'"
              variant="outline-primary"
              @click="userAddSidebarActive = true"
            >
              Nuevo Usuario
            </b-button>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar (nombre o correo)"
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        class="position-relative"
        hover
        responsive
        small
        primary-key="id"
        show-empty
        empty-text="No se encontraron registros coincidientes"
        :busy="tableIsBusy"
        :items="usersData"
        :fields="usersFields"
        :per-page="perPage"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>

        <!-- Column: Id -->
        <template #cell(id)="data">
          <b-link
            class="font-weight-bold text-primary"
            @click="openEditForm(data.item.id)"
          >
            {{ data.item.id }}
          </b-link>
        </template>

        <!-- Column: Name -->
        <template #cell(name)="data">
          <b-link
            class="font-weight-bold text-primary"
            @click="openEditForm(data.item.id)"
          >
            {{ data.item.name }}
          </b-link>
        </template>

        <!-- Column: Email -->
        <template #cell(email)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.email }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Employee ID -->
        <template #cell(employee_id)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.employee_id || 'Sin ID' }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Role -->
        <template #cell(role)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ (data.item.role === 'admin') ? 'Administrador' : 'Vendedor' }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Sales Target -->
        <template #cell(sales_target)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.sales_target ? `Q${parseFloat(data.item.sales_target).toLocaleString()}` : 'Sin meta' }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="data.item.status === 'Y' ? 'light-success' : 'light-danger'"
          >
            {{ data.item.status === 'Y' ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>

        <!-- Column: Chat Enabled -->
        <template #cell(chat_enabled)="data">
          <b-badge :variant="data.item.chat_enabled ? 'light-info' : 'light-secondary'">
            {{ data.item.chat_enabled ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>

        <!-- Column: Created At -->
        <template #cell(created_at)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.created_at }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Updated At -->
        <template #cell(updated_at)="data">
          <span class="text-nowrap">
            <div class="d-flex flex-column">
              <span class="text-body-heading">{{ data.item.updated_at }}</span>
            </div>
          </span>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="userData().role === 'admin'"
          #cell(actions)="data"
        >
          <div class="text-nowrap">
            <!-- Dropdown -->
            <b-dropdown
              variant="link"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="(data.item.status === 'Y')"
                @click="changeStatus(data.item.id, 'Y')"
              >
                <feather-icon icon="UserMinusIcon" />
                <span class="align-middle ml-50">Inactivar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-else
                @click="changeStatus(data.item.id, 'N')"
              >
                <feather-icon icon="UserPlusIcon" />
                <span class="align-middle ml-50">Activar</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="(data.item.status === 'Y')"
                @click="updatePassword(data.item.id)"
              >
                <feather-icon icon="LockIcon" />
                <span class="align-middle ml-50">Contraseña</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <!-- Pagination info -->
          <b-col
            v-if="usersMeta"
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando del {{ usersMeta.from }} al {{ usersMeta.to }} de {{ usersMeta.total }} registros</span>
          </b-col>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-if="usersMeta"
              v-model="currentPage"
              :total-rows="usersMeta.total"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import UsersAdd from './UsersAdd.vue'
import UsersEdit from './UsersEdit.vue'
import UsersPassword from './UsersPassword.vue'

export default {
  components: {
    vSelect,
    UsersAdd,
    UsersEdit,
    UsersPassword,
  },

  data() {
    return {
      userAddSidebarActive: false,
      userEditSidebarActive: false,
      userPasswordSidebarActive: false,

      searchQuery: '',
      searchQueryTimeout: null,

      sortField: 'id',
      sortDirection: 'asc',

      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      currentPage: 1,

      usersFields: [
        { key: 'actions', label: '' },
        { key: 'id', label: 'ID', sortable: true },
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'email', label: 'Correo', sortable: true },
        { key: 'employee_id', label: 'ID Empleado', sortable: true },
        { key: 'role', label: 'Rol', sortable: true },
        { key: 'sales_target', label: 'Meta de Venta', sortable: true },
        { key: 'status', label: 'Estado', sortable: true },
        { key: 'chat_enabled', label: 'Asistente IA', sortable: true },
        { key: 'created_at', label: 'Creado', sortable: true },
        { key: 'updated_at', label: 'Actualizado', sortable: true },
      ],
      usersData: null,
      usersMeta: null,

      updateShow: false,
      passwordShow: false,
      userId: 0,
      tableIsBusy: true,
    }
  },

  watch: {
    searchQuery() {
      clearTimeout(this.searchQueryTimeout)
      this.searchQueryTimeout = setTimeout(() => {
        this.getUsers()
      }, 300)
    },
    perPage() {
      this.getUsers()
    },
    currentPage() {
      this.getUsers()
    },
  },

  mounted() {
    this.getUsers()
  },

  methods: {
    userData() {
      return JSON.parse(localStorage.getItem('DuttonAuthUser'))
    },

    async getUsers() {
      this.tableIsBusy = true
      try {
        const params = {
          page: this.currentPage,
          perPage: this.perPage,
          query: this.searchQuery,
          sortField: this.sortField,
          sortDesc: this.sortDirection,
        }

        const response = await axios.get('system/users', { params })
        this.usersData = response.data.data
        this.usersMeta = response.data.meta
      } catch (error) {
        this.makeToast('danger', 'Error', 'Error al cargar los usuarios')
      } finally {
        this.tableIsBusy = false
      }
    },

    openEditForm(id) {
      this.updateShow = true
      this.userEditSidebarActive = true
      this.userId = id
    },

    updatePassword(id) {
      this.passwordShow = true
      this.userPasswordSidebarActive = true
      this.userId = id
    },

    changeStatus(id, status) {
      this.$bvModal
        .msgBoxConfirm('¿Deseas cambiar el estado actual del usuario?', {
          title: (status === 'N') ? 'Activar usuario' : 'Inactivar usuario',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          okTitleVariant: 'outline-danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            axios
              .put(`system/users/${id}/status`)
              .then(response => {
                const msg = (status === 'N') ? 'Activado' : 'Inactivado'
                this.makeToast('success', msg, `Se ha actualizado el estado del usuario ${response.data.data.name}.`)
                this.getUsers()
              })
              .catch(error => {
                this.showErrors(error)
              })
          }
        })
    },

    makeToast(variant = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      })
    },

    showErrors(error) {
      let errorMessage = 'Error en la operación'

      if (error.response && error.response.data && error.response.data.errors) {
        const { errors } = error.response.data
        errorMessage = Object.values(errors).flat().join(', ')
      } else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      }

      this.makeToast('danger', 'Error', errorMessage)
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
